import type { ArticleCardsList } from '@backmarket/http-api/src/api-specs-content/models/article-cards-list'

// TODO COM-1345 Remove the mapping
export function mapToArticles(props: ArticleCardsList = {}) {
  if ('articles' in props && props.articles) return props.articles
  if ('guides' in props && props.guides) return props.guides

  return []
}
